import SchemaForm from 'components/forms/SchemaForm'
import React from 'react'
import { connect } from 'react-redux'
import signatureSchema from "../../forms/signatureSchema";

class SignatureForm extends React.Component {
  render () {
    return (
      <SchemaForm entityName='employment' {...this.props}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    uiSchema: signatureSchema(state, ownProps)
  }
}

SignatureForm.defaultProps = {
  submitButton: true
}

export default connect(mapStateToProps)(SignatureForm);
